import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const TaxTypesViewChunk = lazy(() =>
  import('../feature-sets/TaxTypesView').then(({ TaxTypesView }) => ({
    default: TaxTypesView,
  }))
)

export const ManageTaxTypesPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.manageTaxTypesTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsTitle),
        },
        {
          link: '/settings/tax',
          name: intl.formatMessage(messages.manageTaxTypesTitle),
        },
      ]}
    >
      <TaxTypesViewChunk />
    </Page>
  )
}
